module.exports = __webpack_public_path__ + "static/bamboo-right-3d30654528def0fbb1d2d92816b8de7b.png";